import React from 'react';
import { faFacebook, faGithub, faGoogle, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faPhoneVolume, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Sidebar.css';

const Sidebar = () => {
    return (
        <div>
            <div className="social-icons">
                <div className="icons">
                    <div className="social-links">
                        <a target="_blank" href="https://github.com/Tanjin9185">
                            <FontAwesomeIcon className="icon animation-rotate" icon={faGithub}></FontAwesomeIcon></a>
                        <a target="_blank" href="https://www.linkedin.com/in/tanjin-ahamed-708022186/"><FontAwesomeIcon className="icon animation-rotate" icon={faLinkedin}></FontAwesomeIcon></a>
                        <a target="_blank" href="https://www.facebook.com/tanjin.ahamed.353"><FontAwesomeIcon className="icon animation-rotate" icon={faFacebook}></FontAwesomeIcon></a>
                        <a target="_blank" href="https://www.instagram.com/"><FontAwesomeIcon className="icon animation-rotate" icon={faInstagram}></FontAwesomeIcon></a>
                        <a href="/"><FontAwesomeIcon className="icon animation-rotate" icon={faGoogle}></FontAwesomeIcon></a>
                    </div>
                </div>
            </div>
            <div className="personal-email">
                <div className="email">
                    <div className="email-link" id="nav-links">
                        <a href="mailto:tanjin.ahamed123@gmail.com"><FontAwesomeIcon className="icon animation-rotate" icon={faEnvelope}></FontAwesomeIcon></a>
                        {/* <br /> */}
                        <a href="tel:+8801619980401"><FontAwesomeIcon className="icon animation-rotate" icon={faPhoneVolume}></FontAwesomeIcon></a>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;